<script>
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import bem from '@/utils/bem';
import TABS from '@/pages/deliveries/TABS';
import { mapActions, mapGetters } from 'vuex';
import columns from '@/pages/deliveries/columns';
import {
  CheckOutlined,
  EditOutlined,
  DownOutlined,
  UpOutlined,
} from '@ant-design/icons-vue';
import ChangeDelivery from '@/components/modals/Change-delivery.vue';

const b = bem('deliveries-page');
const {
  DIGITIZE, CREATE, ENHANCE, ENHANCE_AND_CREATE,
} = TABS;

const DELIVERIES = [
  {
    title: 'Digitize',
    key: 'digitize',
    types: DIGITIZE,
  },
  {
    title: 'Enhance',
    key: 'enhance',
    types: ENHANCE,
  },
  {
    title: 'Create',
    key: 'create',
    types: CREATE,
  },
  {
    title: 'Enhance & Create',
    key: 'enhanceCreate',
    types: ENHANCE_AND_CREATE,
  },
];
export default {
  components: {
    UpOutlined,
    CheckOutlined,
    EditOutlined,
    PageHeader,
    ChangeDelivery,
    DownOutlined,
  },
  data() {
    return {
      title: 'Deliveries',
      type: 'shipping',
      deliveries: DELIVERIES,
      columns: columns(),
      key: 'digitize',
      name: 'inStoreOrder',
      selectedId: 0,
      editableData: {},
      selectedField: '',
      showEdit: false,
      sortedDeliveries: [],
      tabTitle: '',
      subTabTitle: '',
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getDeliveriesAction: 'products/getProducts',
      updateDeliveryAction: 'products/updateProduct',
      updateOptionPositionsAction: 'products/updateOptionPositions',
      getAllProductsAction: 'products/getAllProducts',
    }),
    openEditWindow(id) {
      this.selectedId = id;
      this.showEdit = true;
    },
    edit(value, fieldType) {
      this.editableData = value;
      this.selectedField = fieldType;
    },
    save(value) {
      const newValue = {
        id: value.id,
        type: this.type,
        additionalDiscount: value.additionalDiscount || 0,
        displayName: value.displayName || '',
        subName: value.subName || '',
        displayText: value.displayText || '',
        price: value.price || 0,
      };
      this.updateDeliveryAction(newValue);
      this.editableData = {};
      this.selectedField = '';
    },
    changeToggle(record, field, value) {
      const newValue = {
        id: record.id,
        type: this.type,
        ext: {
          shippingSettings: {
            activeCreate: record.ext.shippingSetting.activeCreate,
            activeDigitize: record.ext.shippingSetting.activeDigitize,
            activeEnhance: record.ext.shippingSetting.activeEnhance,
            activeGiftCard: record.ext.shippingSetting.activeGiftCard,
            displayAtCheckout: record.ext.shippingSetting.displayAtCheckout,
            recycle: record.ext.shippingSetting.recycle,
            localPickUp: record.ext.shippingSetting.localPickUp,
            localZipCodes: record.ext.shippingSetting.localZipCodes,
            [field]: value,
          },
        },
      };
      this.updateDeliveryAction(newValue);
    },
    onSelect(key, name) {
      this.key = key;
      this.name = name;
      if (key === 'position') {
        this.sortedDeliveries = this.deliveriesProducts;
      } else {
        this.sortedDeliveries = [];
        const sortedKeyDeliveries = this.deliveries.find((item) => item.key === key);
        const typesSortedKeyDeliveries = sortedKeyDeliveries.types;
        this.tabTitle = sortedKeyDeliveries.title;
        const sortedNameAndKeyDeliveries = typesSortedKeyDeliveries
          .find((sortItem) => sortItem.name === name);
        const { productsList, displayName } = sortedNameAndKeyDeliveries;
        this.subTabTitle = displayName;
        this.deliveriesProducts.forEach((item) => {
          if (productsList.includes(item.name)) {
            this.sortedDeliveries = [...this.sortedDeliveries, item];
            this.sortedDeliveries = this.sortedDeliveries.sort((a, c) => a.index - c.index);
          }
        });
      }
    },
    changePosition(currentValue, replaceValue) {
      this.updateOptionPositionsAction({
        type: this.type,
        changePosition: [currentValue, replaceValue],
      });
    },
  },
  computed: {
    ...mapGetters({
      deliveriesProducts: 'products/sortedProductsByIndex',
    }),
  },
  mounted() {
    this.getDeliveriesAction(this.type);
    this.getAllProductsAction();
  },
  watch: {
    deliveriesProducts(newValue) {
      newValue.map((item, idx) => {
        if (!item.index) {
          return {
            ...item,
            index: idx,
          };
        }
        return item;
      });
      this.onSelect(this.key, this.name);
    },
  },
};
</script>

<template>
  <PageHeader :title="title" />
  <div :class="b('')">
    <div :class="b('headers')">
      <div :class="b('buttons-menu')">
        <a-dropdown
          :class="b('buttons-menu-item')"
          v-for="delivery in deliveries"
          :key="delivery.key"
        >
          <template #overlay>
            <a-menu>
              <a-menu-item
                v-for="item in delivery.types"
                :key="item.name"
                @click="this.onSelect(delivery.key, item.name)"
              >
                {{ item.displayName }}
              </a-menu-item>
            </a-menu>
          </template>
          <a-button>
            {{ delivery.title }}
            <DownOutlined />
          </a-button>
        </a-dropdown>
        <a-button
          @click="this.onSelect('position', '')"
        >
          Position
        </a-button>
      </div>
      <h2>Active tab: {{ tabTitle }} > {{ subTabTitle }}</h2>
    </div>
    <div v-if="deliveriesProducts && deliveriesProducts.length">
      <a-table
        :columns="columns"
        :dataSource="sortedDeliveries"
        :pagination="false"
      >
        <template #bodyCell="{ column, text, record, index }">
          <template v-if="column.dataIndex === 'displayName'">
            <div >
              <div v-if="
                editableData.displayName
                && editableData.displayName === record.displayName
                && selectedField === 'displayName'
              ">
                <a-input v-model:value="editableData.displayName" @pressEnter="save(record)" />
                <check-outlined @click="save(record)" />
              </div>
              <div v-else >
                {{ text || ' ' }}
                <edit-outlined @click="edit(record, 'displayName')" />
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'subName'">
            <div >
              <div v-if="
                editableData.subName &&
                editableData.subName === record.subName
                && selectedField === 'subName'
              ">
                <a-input v-model:value="editableData.subName" @pressEnter="save(record)" />
                <check-outlined @click="save(record)" />
              </div>
              <div v-else >
                {{ text || ' ' }}
                <edit-outlined @click="edit(record, 'subName')" />
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'displayText'">
            <div >
              <div v-if="
                editableData.displayText &&
                editableData.displayText === record.displayText
                && selectedField === 'displayText'
              ">
                <a-input v-model:value="editableData.displayText" @pressEnter="save(record)" />
                <check-outlined @click="save(record)" />
              </div>
              <div v-else >
                {{ text || ' ' }}
                <edit-outlined @click="edit(record, 'displayText')" />
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'price'">
            <div :class="b('row')" v-if="
              editableData.price &&
              editableData.price === record.price
              && selectedField === 'price'
            ">
              <a-input
                type="number"
                style="width: 75px"
                v-model:value="editableData.price"
                @pressEnter="save(record)"
              />
              <check-outlined @click="save(record)" />
            </div>
            <div v-else >
              {{ text || '0' }}
              <edit-outlined @click="edit(record, 'price')" />
            </div>
          </template>
          <template v-if="column.dataIndex === 'additionalDiscount'">
            <div :class="b('row')" v-if="
              editableData.additionalDiscount &&
              editableData.additionalDiscount === record.additionalDiscount
              && selectedField === 'additionalDiscount'
            ">
              <a-input
                type="number"
                style="width: 75px"
                v-model:value="editableData.additionalDiscount"
                @pressEnter="save(record)" />
              <check-outlined @click="save(record)" />
            </div>
            <div v-else >
              {{ text || '0' }}
              <edit-outlined @click="edit(record, 'additionalDiscount')" />
            </div>
          </template>
          <template v-if="column.dataIndex === 'active'">
            <div :class="b('column-wrapper')">
              <div :class="b('item-wrapper')">
                <h4>Digitize: </h4>
                <a-switch
                  :checked="record.ext.shippingSetting.activeDigitize || false"
                  @change="changeToggle(
                    record,
                    'activeDigitize',
                    !record.ext.shippingSetting.activeDigitize || true)"
                ></a-switch>
              </div>
              <div :class="b('item-wrapper')">
              <h4>Enhance: </h4>
                <a-switch
                  :checked="record.ext.shippingSetting.activeEnhance || false"
                  @change="changeToggle(
                    record,
                    'activeEnhance',
                    !record.ext.shippingSetting.activeEnhance)"
                ></a-switch>
              </div>
              <div :class="b('item-wrapper')">
              <h4>Create: </h4>
                <a-switch
                  :checked="record.ext.shippingSetting.activeCreate || false"
                  @change="changeToggle(
                    record,
                    'activeCreate',
                    !record.ext.shippingSetting.activeCreate)"
                ></a-switch>
              </div>
              <div :class="b('item-wrapper')">
              <h4>Gift Card: </h4>
                <a-switch
                  :checked="record.ext.shippingSetting.activeGiftCard || false"
                  @change="changeToggle(
                    record,
                    'activeGiftCard',
                    !record.ext.shippingSetting.activeGiftCard)"
                ></a-switch>
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'checkout'">
            <div :class="b('column-wrapper')">
              <div :class="b('item-wrapper')">
                <a-switch
                  :checked="record.ext.shippingSetting.displayAtCheckout || false"
                  @change="changeToggle(
                    record,
                    'displayAtCheckout',
                    !record.ext.shippingSetting.displayAtCheckout)"
                ></a-switch>
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'local'">
            <div :class="b('column-wrapper')">
              <div :class="b('item-wrapper')">
                <h4>Local pick up: </h4>
                <a-switch
                  :checked="record.ext.shippingSetting.localPickUp || false"
                  @change="changeToggle(
                    record,
                    'localPickUp',
                    !record.ext.shippingSetting.localPickUp)"
                ></a-switch>
              </div>
              <div :class="b('item-wrapper')">
                <h4>Local zip codes: </h4>
                <a-switch
                  :checked="record.ext.shippingSetting.localZipCodes || false"
                  @change="changeToggle(
                    record,
                    'localZipCodes',
                    !record.ext.shippingSetting.localZipCodes)"
                ></a-switch>
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'recycle'">
            <div :class="b('column-wrapper')">
              <div :class="b('item-wrapper')">
                <a-switch
                  :checked="record.ext.shippingSetting.recycle || false"
                  @change="changeToggle(
                    record,
                    'recycle',
                    !record.ext.shippingSetting.recycle)"
                ></a-switch>
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'actions'">
            <div :class="b('actions')">
              <div v-if="key === 'position'" :class="b('order-buttons') ">
                <a-button
                  :class="b('order-button-up')"
                  v-if="index > 0"
                  type="primary"
                  html-type="button"
                  @click="changePosition(
                    { id: record.id, index: index - 1 },
                    { id: sortedDeliveries[index - 1].id, index },
                  )"
                >
                  <template #icon>
                    <UpOutlined />
                  </template>
                </a-button>
                <a-button
                  v-if="index !== sortedDeliveries.length - 1"
                  type="primary"
                  html-type="button"
                  @click="changePosition(
                    { id: record.id, index: index + 1 },
                    { id: sortedDeliveries[index + 1].id, index },
                  )"
                >
                  <template #icon>
                    <DownOutlined />
                  </template>
                </a-button>
              </div>
              <a-button
                type="primary"
                html-type="button"
                @click="openEditWindow(record.id)"
              >
                Edit
              </a-button>
              <div v-if="showEdit && selectedId === record.id">
                <change-delivery
                  :type="type"
                  :deliveryKey="key"
                  :delivery="record"
                  v-model:show="showEdit"
                />
              </div>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.deliveries-page {
  margin: 0 20px;
  &__headers {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
  }
  &__buttons-menu-item {
    margin-right: 20px;
  }
  &__column-wrapper {
    display: flex;
    flex-direction: column;
  }
  &__item-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    h4 {
      margin: 0;
    }
  }
  &__item-wrapper:last-child {
    padding-bottom: 0;
  }
  &__actions {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  &_order-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  &__order-button-up {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
